function selectMark() {
// function formatMark (mark) {
//   if (!mark.id) {
//       return mark.text;
//     }
//     var optimage = $(mark.element).data('image');
//     var $state = $(
//       '<span><img src="' + optimage + '" class="img-flag" /> ' + mark.text + '</span><span class="select__option-hover">перейти <img src="/i/lera/i-selectmark_arrow.svg"></span>'
//     );
//     return $state;
//   };
//
// $(".selectmark__select").select2({
//   placeholder: "Введите марку вашей машины:",
//   templateResult: formatMark
// });
$('.js-selectmark__see').click(function(e){
	e.preventDefault();
    $('.js-avtoprod__populare').toggleClass('moremarks');
    $('.js-avtoprod__all').toggleClass('moremarks');
    $(this).css('display','none');
	$('.js-avtomark__letters').addClass('m--show-all');
})
$('.js-selectmark__term').on('keyup',function(){
  if ($(this).val().length > 1) {
    $.ajax({
      method: "POST",
      url: "/autocomplete/",
      data: { term: $(this).val()}
    }).then((data) => {
      $(this).siblings('.js-selectmark__term--result').html('');
      for (var i = 0; i < 100; i++) {
        if (data[i].class_name == 'brand') {
          var class_name = "Марка"
        } else if (data[i].class_name == 'model') {
          var class_name = "Модель"
        } else {
          var class_name = "Модификация"
        }
        $(this).siblings('.js-selectmark__term--result').append('<a href="'+data[i].value+'" class="selectmark__term--item">'+data[i].label+'<span>'+class_name+'</span></a>');
      }
    })
  }
})
$('.js-selectmark__term').click(function(){
  $(this).siblings('.js-selectmark__term--result').css('display','block');
  $(this).parents('.js-efects-click').addClass('active');
})
$(document).mouseup(function (e){
    var div = $(".js-efects-click");
    var div2 = $(".js-selectmark__term--result");
    if ((!div.is(e.target) && $('.js-selectmark__term').val() == '')) {
      $('.js-efects-click').removeClass('active');
    }
    if ((!div.is(e.target) || !div2.is(e.target))) {
      $('.js-selectmark__term--result').css('display','none');
    }
})
// $(document).mouseup(function (e){ // событие клика по веб-документу
//       var div = $(".totop"); // тут указываем ID элемента
//       var div2 = $(".select2-container"); // тут указываем ID элемента
//       if (!div.is(e.target)
//       && div.has(e.target).length === 0
//       && !div2.is(e.target)
//       && div2.has(e.target).length === 0 && !$('.select2.select2-container').hasClass('select2-container--open')) {
//           if($('.select2-hidden-accessible').val() == '') {
//                  $('.select2').parent('.totop').removeClass('active');// скрываем его
//           }
//       }
//   });
//   $('.select2-selection__rendered').html('<span class="select2-selection__placeholder">Введите марку вашей машины:</span>');
//   $('.js-efects-click').click(function(){
//     if ($(this).children('select')) {
//       $('.select2-search__field').focus();
//     }
//   })
//   $('.js-selectmark__select').change(function() {
//     window.location.href = $('.js-selectmark__select option:selected').attr('data-src');
//   })
}

export {
  selectMark
};
